import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Messages Redux States
import { FAVORITE_SCRIPT,GET_SCRIPT } from "./actionTypes";
import { favoritedScript,favoritedScriptApiError } from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* favoriteScript({ payload: { scriptId, remove } }) {
  try {
    const response = yield call(
      axios.patch,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/script/favorite/${scriptId}`,
      { remove: remove }
    );

    if (response.status === 200) {
      yield put(favoritedScript({ favoriteScript: response.data.data.favorite_messages,scriptId}));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(favoritedScriptApiError(message));
  }
}

function* getScript() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/script/favorite`    );

    if (response.status === 200) {
      yield put(favoritedScript({ favoriteScript: response.data.data.favorite_messages,scriptId: null}));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(favoritedScriptApiError(message));
  }
}

export function* watchStarMsg() {
  yield takeEvery(FAVORITE_SCRIPT, favoriteScript);
}

export function* watchGetScript() {
  yield takeEvery(GET_SCRIPT, getScript);
}

function* authSaga() {
  yield all([fork(watchStarMsg),fork(watchGetScript)]);
}

export default authSaga;
